/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

import axios from 'axios';
import vuetify from './vuetify';
// Sweet Alert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Vue from 'vue';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
// AREA DE CLIENTES
Vue.component('areas-table-component', require('./components/areas/DataTable.vue').default);
Vue.component('clients-table-component', require('./components/clients/DataTable.vue').default);
Vue.component('clients-create-component', require('./components/clients/CreateClient.vue').default);
Vue.component('licences-table-component', require('./components/licences/DataTable.vue').default);
Vue.component('licences-detailed-component', require('./components/licences/Detailed.vue').default);
Vue.component('licences-create-component', require('./components/licences/createLicence.vue').default);
Vue.component('users-table-component', require('./components/users/DataTable.vue').default);
Vue.component('students-table-component', require('./components/students/DataTable.vue').default);
Vue.component('students-table-superadmin-component', require('./components/students/DataTable-Superadmin.vue').default);
Vue.component('students-create-component', require('./components/students/CreateStudent.vue').default);
Vue.component('students-modal-create-component', require('./components/students/MasiveCharge.vue').default);
Vue.component('students-update-component', require('./components/students/UpdateStudent.vue').default);
Vue.component('routes-table-component', require('./components/routes/DataTable.vue').default);
Vue.component('routes-table-superadmin-component', require('./components/routes/DataTable-Superadmin.vue').default);
Vue.component('routes-suggest-component', require('./components/routes/createSuggestRoutes.vue').default);
Vue.component('routes-suggest-card-component', require('./components/routes/cardRoutes.vue').default);
Vue.component('routes-createcustom-component', require('./components/routes/createCustomRouteOld.vue').default);
Vue.component('routes-updatecustom-component', require('./components/routes/updateCustomRoutes.vue').default);
Vue.component('courses-table-component', require('./components/courses/DataTable.vue').default);
Vue.component('courses-users-component', require('./components/courses/CourseUsers.vue').default);
Vue.component('allcourses-component', require('./components/courses/AllCourses.vue').default);
Vue.component('insignias-component', require('./components/insignias/AllInsignias.vue').default);
Vue.component('bootcamp-component', require('./components/bootcamps/DataTable.vue').default);
Vue.component('createbootcamp-component', require('./components/bootcamps/CreateBootcamp.vue').default);

Vue.component('bootcamps-list-component', require('./components/bootcamps/BootcampsList.vue').default);

Vue.component('gridbootcamp-component', require('./components/bootcamps/Grid.vue').default);
Vue.component('courses-enrolled-component', require('./components/courses/CoursesEnrolled.vue').default);
Vue.component('own-courses-create-component', require('./components/courses/CreateOwnCourse.vue').default);
Vue.component('own-courses-edit-component', require('./components/courses/EditOwnCourse.vue').default);
Vue.component('plans-table-component', require('./components/plans/DataTable.vue').default);
Vue.component('plans-create-component', require('./components/plans/CreatePlan.vue').default)
//Vue.component('own-courses-modal-create-component', require('./components/courses/MasiveCharge2.vue').default);
Vue.component('own-courses-table-component', require('./components/courses/DataTable-Courses.vue').default);
Vue.component('own-courses-modal-import-component', require('./components/courses/MasiveCharge.vue').default);
Vue.component('own-courses-sections-modal-import-component', require('./components/courses/MasiveSectionsCharge.vue').default);

Vue.component('courses-catalog-component',require('./components/courses/CatalogWordpressCourses.vue').default);
Vue.component('courses-ranking-component',require('./components/courses/Ranking.vue').default);
Vue.component('courses-stepper-component', require('./components/courses/NewCourseStepper.vue').default);
Vue.component('courses-not-started', require('./components/courses/NewCourseNotStarted.vue').default);
Vue.component('create-course-step-1', require('./components/courses/NewCourseStep1.vue').default);
Vue.component('create-course-step-2', require('./components/courses/NewCourseStep2.vue').default);
Vue.component('create-course-step-2-module', require('./components/courses/NewCourseStep2Module.vue').default);
Vue.component('create-course-step-2-module-lesson', require('./components/courses/NewCourseStep2ModuleLesson.vue').default);
Vue.component('create-course-step-2-questionnaire', require('./components/courses/NewCourseStep2Questionnaire.vue').default);
Vue.component('own-course-created', require('./components/courses/NewCourseCreated.vue').default);

Vue.component('su-dashboard-component', require('./components/dashboards/superadmin.vue').default);
Vue.component('admin-dashboard-component', require('./components/dashboards/admin.vue').default);
Vue.component('informacion-general-component', require('./components/dashboards/informacion_general.vue').default);

Vue.component('tab-students-component', require('./components/students/TabStudents.vue').default);
Vue.component('tab-admins-component', require('./components/users/TabAdmins.vue').default);
Vue.component('tab-companies-component', require('./components/companies/TabCompanies.vue').default);

Vue.component('tab-routes-component', require('./components/routes/TabRoutes.vue').default);
Vue.component('tab-courses-component', require('./components/courses/TabCourses.vue').default);
Vue.component('tab-bootcamps-component', require('./components/bootcamps/TabBootcamps.vue').default);

Vue.component('companies-table-component', require('./components/companies/DataTable.vue').default);
Vue.component('companies-create-component', require('./components/companies/CreateCompany.vue').default);

Vue.component('route-create-custom-component', require('./components/routes/createCustomRoute.vue').default);
Vue.component('routes-default-component', require('./components/routes/DefaultRoutes.vue').default);

Vue.component('tab-plans-component', require('./components/plans/TabPlans.vue').default);

Vue.component('admin-create-component', require('./components/users/CreateUser.vue').default);

Vue.component('show-student-component', require('./components/students/ShowStudent.vue').default);

Vue.component('profile-component', require('./components/dashboards/profile.vue').default);
Vue.component('dashboard-graphics-component', require('./components/dashboards/DashboardGraphics.vue').default);
Vue.component('active-users-graphic-component', require('./components/dashboards/graphics/ActiveUsersGraphic.vue').default);
Vue.component('active-users-week-graphic-component', require('./components/dashboards/graphics/ActiveUsersWeekGraphic.vue').default);
Vue.component('approved-routes-graphic-component', require('./components/dashboards/graphics/ApprovedRoutesGraphic.vue').default);
Vue.component('use-platform-graphic-component', require('./components/dashboards/graphics/UsePlatformGraphic.vue').default);
Vue.component('use-platform-week-graphic-component', require('./components/dashboards/graphics/UsePlatformGraphicWeek.vue').default);
Vue.component('ranking-by-courses-graphic-component', require('./components/dashboards/graphics/RankingByCoursesGraphic.vue').default);
Vue.component('dashboard-new-info-component', require('./components/dashboards/DashboardNewInfo.vue').default);
Vue.component('show-bootcamps-component', require('./components/bootcamps/ShowBootcamps.vue').default);

Vue.component('modal-after-create-component', require('./components/students/ModalAfterCreate.vue').default);

Vue.component('modal-info-component', require('./components/defaults/ModalInfo.vue').default);

Vue.component('loading-component', require('./components/commom/Loading.vue').default);
Vue.component('search-input-component', require('./components/commom/SearchInput.vue').default);
Vue.component('modal-info-commom-component', require('./components/commom/ModalInfo.vue').default);

Vue.component('list-tutorials-component', require('./components/tutorials/ListTutorials.vue').default);

Vue.use(VueSweetalert2);
// FIN DE AREA DE CLIENTES
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    data(){
        return {
            error:'',
            search:'',
            success:"",
            url:'',
            searchResults:'',
        }
    },
    vuetify,
    methods:{
        manageManu(){
            let menu = document.getElementById('navbar');
            if(menu.classList.contains('expanded')) menu.classList.remove('expanded'); else menu.classList.add('expanded');
        },
        generateToken(cliente){
            axios.post('/token',{client:cliente}).then(
                res => {
                    window.location.reload();
                }
            ).catch(err=>{
                console.log(err.response.message);
            })
        },
        crateOrder(url,data,token){
            axios.post(url,data,{
                headers:{
                    token:token
                }
            }).then(
                res=> {
                   console.log(res.data);
                   this.url = res.data.url_public;
                   this.success = res.data.order;
                }
            )
        },
        testSearch(url,token){
            axios.get(url,{
                headers:{
                    token:token
                }
            }).then(
                res => {
                    this.searchResults = res.data
                }
            )
        }
    }
});
